import React from 'react'
import { GoalCanvasZone } from '../goals/GoalCanvasZone.jsx'

/**
 * Zone 1: Read-only goals reminder strip.
 * Before close: live goals filtered to the reflection's period.
 * After close: renders from goalSnapshotsAtClose.
 */
export function ReflectionGoalsStrip({
  ownerUserId,
  reflection,
}) {
  const isClosed = !!reflection?.closedAt
  const snapshots = reflection?.goalSnapshotsAtClose

  return (
    <div style={styles.section}>
      <div style={styles.header}>
        <h3 style={styles.heading}>Goals</h3>
        {isClosed && reflection.closedAt && (
          <span style={styles.snapshotLabel}>
            As of {formatDate(reflection.closedAt)}
          </span>
        )}
      </div>
      <GoalCanvasZone
        ownerUserId={ownerUserId}
        goalSnapshot={isClosed && snapshots ? snapshots : null}
        readOnly={true}
      />
    </div>
  )
}

function formatDate(iso) {
  if (!iso) return ''
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  heading: {
    fontSize: '15px',
    fontWeight: 600,
    margin: 0,
  },
  snapshotLabel: {
    fontSize: '11px',
    color: 'var(--text-secondary)',
    fontStyle: 'italic',
  },
}
